module.exports = __webpack_public_path__ + "static/media/finegrindingmills.89900a8d.png";